import angular from 'angular';
import '../core.module';

export const ROLES = {
  ADMIN: 'admin',
  SUPERVISOR: 'supervisor',
  AGENT: 'agent',
  SALES: 'sales'
};

export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard.view',
  CONVERSATIONS_VIEW: 'conversations.view',
  CRM_MANAGE: 'crm.manage',
  SALES_MANAGE: 'sales.manage',
  SUPPORT_MANAGE: 'support.manage',
  CAMPAIGNS_MANAGE: 'campaigns.manage',
  AUTOMATION_MANAGE: 'automation.manage',
  TEAMS_MANAGE: 'teams.manage',
  SETTINGS_MANAGE: 'settings.manage',
  REPORTS_VIEW: 'reports.view',
  CHANNEL_CONNECT: 'channel.connect',
  CHANNEL_CONFIGURE: 'channel.configure',
  CHANNEL_DISCONNECT: 'channel.disconnect',
  CHANNEL_DELETE: 'channel.delete',
  CHANNEL_EXECUTE_OPERATION: 'channel.execute_operation'
};

angular.module('app.core').constant('ROLES', ROLES).constant('PERMISSIONS', PERMISSIONS);
